import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import mailStore from '../store/Store';
import strings from 'owa-strings/owa-mini-strings';
import { getFolderDisplayName } from './getFolderDisplayName';
import { MSG_FOLDER_ROOT } from 'mini-mail-common/lib/utils/folderNameConstants';

/**
 * Helper function to get display name of selected folder
 * @param folderId
 * @param isLogging - If true, returns name from folderTable for "all folders" folderId. Only used for logging in executeSearch
 */
export default function getFolderDisplayNameFromId(
    folderId: string,
    isLogging: boolean = false
): string {
    if (!folderId) {
        return '';
    }

    const { folderTable } = mailStore.folders;
    const isAllFolders = folderId === folderNameToId(MSG_FOLDER_ROOT);

    const folderDisplayName =
        isAllFolders && !isLogging
            ? strings.allFolders
            : getFolderDisplayName(folderTable.get(folderId));

    return folderDisplayName || '';
}
